import { useMutation } from 'react-query';
import axios from '../utils/axios-util';

const requestCache = {};

const executeRequest = async (url, method, data) => {
  if (!url) return false;

  // Check if the request has been cached
  const cacheKey = JSON.stringify([url, method, data]);
  if (requestCache[cacheKey]) {
    return requestCache[cacheKey];
  }

  const response = await axios({
    url: url,
    method: method,
    headers: { 'Content-Type': 'application/json' },
    data: data
  });

  // Store the response in the cache
  requestCache[cacheKey] = response.data;
  return response.data;
};

const useScriptExecution = (url, method = 'post') => {
  return useMutation((data) => executeRequest(url, method, data));
};

export default useScriptExecution;
